import {
  TABLE_MANAGEMENT_MAP_PAGE_REQUEST,
  TABLE_MANAGEMENT_MAP_DROPDOWN_SELECT_GROUP,
  TABLE_MANAGEMENT_MAP_SUBMIT_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_SUBMIT_EDIT_TABLE,
  TABLE_MANAGEMENT_MAP_SUBMIT_DELETE_TABLE,
  TABLE_MANAGEMENT_MAP_SUBMIT_SAVE_LAYOUT,
  TABLE_MANAGEMENT_MAP_ON_CHANGE_OUTLET_IDS,
} from 'actions/tableManagement/constants';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { initialize, change } from 'redux-form';
import _cloneDeep from 'lodash/cloneDeep';

import * as apiOutlets from 'api/outlets';
import * as actTableManagement from 'actions/tableManagement';
import * as apiProfile from 'api/profile';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as apiTableManagement from 'api/tableManagement';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as clevertapTableManagement from 'clevertap/tableManagement';
import { setSelectedOutletIds } from 'actions/actionBar';

export const getBusinessId = state => state.moka.user.business.id;
export const getOutletId = state => state.moka.user.outlet_id[0];

function* fillForm(group) {
  yield put(
    initialize('search', {
      search: group.search,
    })
  );
}

export function* fetchSummary() {
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiTableManagement.getGroupSummary);
    return response.data;
  } catch (error) {
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(act.hideProgressBar());
  }
}

function* fillSearch(profile) {
  let assignedOutletIds = [];
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]];
  } else {
    assignedOutletIds = profile.outlet_id;
  }
  const data = { outletIds: assignedOutletIds };
  yield put(initialize('search', data));
}

export function* mapPageRequestFlow(request) {
  const { groupDetail } = request.payload;

  yield put(showPageLoadingSpinner(true));
  yield put(actTableManagement.setGroups([]));
  yield put(actTableManagement.setFilteredGroups([]));
  yield put(actTableManagement.setGroupSummary([]));
  yield put(actTableManagement.setGroupDetail(null));
  yield put(act.showProgressBar());
  try {
    yield call(fillForm, { search: '' });
    yield call(groupsRequest, { page: 1, keyword: '', groupDetail });
    const response = yield call(apiOutlets.outlets);
    yield put(actTableManagement.setOutlets(response.data));
    const resProfile = yield call(apiProfile.getProfile);
    yield call(fillSearch, resProfile.data);
    yield put(actTableManagement.groupSummaryRequest({}));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onChangeOutletIdsMap(request) {
  yield put(actTableManagement.closeRightColumn());
  yield put(actTableManagement.setGroups([]));
  yield put(actTableManagement.setFilteredGroups([]));
  yield put(actTableManagement.setGroupSummary([]));
  yield put(actTableManagement.setGroupDetail(null));
  yield put(actTableManagement.setTables([]));
  yield put(actTableManagement.setOriginalTables([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { outletIds },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield call(apiOutlets.patchLogin, { id: outletIds });
    const resProfile = yield call(apiProfile.getProfile);
    yield put(setSelectedOutletIds(outletIds));
    yield put(change('search', 'outletIds', outletIds));
    yield put(actTableManagement.unSetFilterState());
    yield call(fillForm, { search: '' });
    yield call(fillSearch, resProfile.data);
    yield call(groupsRequest, { page: 1, keyword: '' });
    yield put(actTableManagement.groupSummaryRequest({}));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* dropDownSelectTableGroup(request) {
  let { id } = request.payload;
  id = parseInt(id);
  try {
    yield put(actTableManagement.setGroupDetail(null));
    yield put(actTableManagement.setTables([]));
    yield put(actTableManagement.setOriginalTables([]));
    yield put(act.showProgressBar());
    const outletId = yield select(getOutletId);
    if (id !== 0) {
      const groupDetailRes = yield call(
        apiTableManagement.getTableGroup,
        id,
        {},
        outletId
      );
      const { data: groupDetail } = groupDetailRes;
      yield put(actTableManagement.setGroupDetail(groupDetail));
      if (groupDetail) {
        const tablesRes = yield call(
          apiTableManagement.getTableGroupTables,
          id,
          {},
          outletId
        );
        const tables = tablesRes.data;
        const originalTables = _cloneDeep(tables);
        yield put(actTableManagement.setTables(tables));
        yield put(actTableManagement.setOriginalTables(originalTables));
      } else {
        yield put(actTableManagement.setTables([]));
        yield put(actTableManagement.setOriginalTables([]));
      }
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(actTableManagement.setMustScrollTop(false));
    yield put(change('search', 'groupId', id));
  }
}

export function* getTableGroups(params) {
  yield put(act.showProgressBar());
  try {
    const outletId = yield select(getOutletId);
    const response = yield call(
      apiTableManagement.getTableGroups,
      params,
      outletId
    );
    return response.data;
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* groupsRequest(request) {
  let keyword;
  let page;
  let previousGroups;
  let groups;
  if (request.payload) {
    const requestPayload = request.payload.query;
    const { filterState } = requestPayload;
    previousGroups = request.payload.previousGroups;
    keyword = filterState.keyword;
    page = requestPayload.page;
  } else {
    keyword = request.keyword;
    page = request.page;
  }
  const query = {
    page,
    keyword: !keyword ? '' : keyword,
  };
  yield put(act.showProgressBar());
  try {
    const groupsResponse = yield call(getTableGroups, query);
    if (previousGroups) {
      groups = previousGroups.concat(groupsResponse);
    } else {
      groups = groupsResponse;
    }
    yield put(actTableManagement.setGroups(groups));
    yield put(actTableManagement.setFilteredGroups(groups));
    if (page <= 1) {
      const summary = yield call(fetchSummary, query);
      yield put(actTableManagement.setGroupSummary(summary));
      yield put(actTableManagement.setTotalPage(summary.total_pages));
    }
    yield put(actTableManagement.setCurrentPage(page));

    if (request.groupDetail) {
      yield put(
        actTableManagement.dropDownSelectTableGroup(request.groupDetail.id)
      );
    } else if (groups.length) {
      yield put(actTableManagement.dropDownSelectTableGroup(groups[0].id));
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(showPageLoadingSpinner(false));
}

export function* submitAddTable(request) {
  const { table, tables, originalTables, groupDetail } = request.payload;
  yield put(act.showProgressBar());
  tables.push(table);
  yield put(actTableManagement.setTables(tables));
  yield put(actTableManagement.updateSaveLayoutButton(tables, originalTables));
  yield put(actNotif.success('Table Successfully Added.'));
  clevertapTableManagement.addTableSuccess({
    name: table.name,
    maxPax: table.maxPax,
    shape: table.shape,
    groupName: groupDetail.name,
  });
  yield put(act.hideProgressBar());
  yield put(actTableManagement.closeAddTableModal());
}

export function* submitEditTable(request) {
  const { tables, originalTables, table, groupDetail } = request.payload;
  yield put(act.showProgressBar());
  const idx = tables.findIndex(_table => _table.name === table.oldName);
  tables[idx] = table;
  yield put(actTableManagement.setTables(tables));
  yield put(actTableManagement.updateSaveLayoutButton(tables, originalTables));
  yield put(actNotif.success('Table Successfully Updated.'));
  clevertapTableManagement.editTableSuccess(table, groupDetail);
  yield put(act.hideProgressBar());
  yield put(actTableManagement.closeEditTableModal());
}

export function* submitDeleteTable(request) {
  const { tables, originalTables, table } = request.payload;
  yield put(act.showProgressBar());
  const idx = tables.findIndex(_table => _table.name === table.name);
  tables.splice(idx, 1);
  yield put(actTableManagement.setTables(tables));
  yield put(actTableManagement.updateSaveLayoutButton(tables, originalTables));
  yield put(actNotif.success('Table Successfully Deleted.'));
  clevertapTableManagement.deleteTableSuccess(table);
  yield put(actTableManagement.hideTableMapDeleteModal());
  yield put(act.hideProgressBar());
}

export function* submitSaveLayout(request) {
  const { originalTables, groupDetail } = request.payload;
  let { tables } = request.payload;
  try {
    yield put(act.showProgressBar());
    const outletId = yield select(getOutletId);
    const savedTablesRes = yield call(
      apiTableManagement.saveTableGroupTables,
      groupDetail.id,
      tables,
      {},
      outletId
    );
    const savedTables = savedTablesRes.data;
    yield put(
      actNotif.success(
        'Table Layout Successfully Saved. The changes will happen when there is no open bill on mobile devices'
      )
    );
    const newTableCount = savedTables.length;
    const oldTableCount = tables.length;
    const { active } = groupDetail;
    let movement = 'No';
    for (const table1 of originalTables) {
      const idx = savedTables.findIndex(table2 => {
        return (
          table2.id === table1.id &&
          (table1.rowNum !== table2.rowNum ||
            table1.columnNum !== table2.columnNum)
        );
      });
      if (idx !== -1) {
        movement = 'Yes';
        break;
      }
    }
    clevertapTableManagement.tableMapSaveChanges({
      active,
      oldTableCount,
      newTableCount,
      movement,
    });
  } catch (error) {
    if (error.data.data) {
      tables = error.data.data;
    }
    yield put(actNotif.error(error.data.message));
    tables = _cloneDeep(originalTables);
  } finally {
    const originalTables = _cloneDeep(tables);
    yield put(actTableManagement.setTables(tables));
    yield put(actTableManagement.setOriginalTables(originalTables));
    yield put(
      actTableManagement.updateSaveLayoutButton(tables, originalTables)
    );
    yield put(act.hideProgressBar());
  }
}

export default function* tableManagementMapSaga() {
  yield takeLatest(
    TABLE_MANAGEMENT_MAP_ON_CHANGE_OUTLET_IDS,
    onChangeOutletIdsMap
  );
  yield takeLatest(
    TABLE_MANAGEMENT_MAP_DROPDOWN_SELECT_GROUP,
    dropDownSelectTableGroup
  );
  yield takeLatest(TABLE_MANAGEMENT_MAP_PAGE_REQUEST, mapPageRequestFlow);
  yield takeLatest(TABLE_MANAGEMENT_MAP_SUBMIT_ADD_TABLE, submitAddTable);
  yield takeLatest(TABLE_MANAGEMENT_MAP_SUBMIT_EDIT_TABLE, submitEditTable);
  yield takeLatest(TABLE_MANAGEMENT_MAP_SUBMIT_DELETE_TABLE, submitDeleteTable);
  yield takeLatest(TABLE_MANAGEMENT_MAP_SUBMIT_SAVE_LAYOUT, submitSaveLayout);
}
